export var defaultState = {
    collection: {
        status: 'unloaded',
        items: [],
    },
    item: {
        status: 'unloaded',
        item: null,
    },
};
